import React from "react";
import { Dropdown, Space, Image } from "antd";
import { useDispatch } from "react-redux";
import { setAdminLoggedTrigger } from "../../redux/actions/mainAction";
import { Link } from "react-router-dom";

const MainAvatar = () => {
  const dispatch = useDispatch();

  const employeeName = JSON.parse(localStorage.getItem("user"))?.employeeName;
  const employeeImage = JSON.parse(localStorage.getItem("user"))?.employeeImage;

  const clearLocalStorage = () => {
    localStorage.clear();
    dispatch(setAdminLoggedTrigger(Math.random()));
  };

  const items = [
    {
      key: "1",
      label: <Link to="/profile">Profilim</Link>,
    },

    {
      key: "2",
      danger: true,
      label: <a onClick={clearLocalStorage}>Sistemdən çıx</a>,
    },
  ];
  return (
    <>
      <Dropdown
        menu={{
          items,
        }}
      >
        <a onClick={(e) => e.preventDefault()}>
          <Space>
            <span>{employeeName} </span>
            <Image
              preview={false}
              className="profile-header-image"
              src={employeeImage}
            />
          </Space>
        </a>
      </Dropdown>
    </>
  );
};

export default MainAvatar;
